import { Icon } from '@procurify/ui'

import { ConversationOrderSummaryThumbnailStyled } from './styles/ConversationOrderSummaryThumbnailStyled'

export interface IConversationOrderSummaryThumbnailProps {
  img?: string
}

export const ConversationOrderSummaryThumbnail = ({
  img,
}: IConversationOrderSummaryThumbnailProps) => (
  <ConversationOrderSummaryThumbnailStyled>
    {img ? (
      <img src={img} alt='' className='fs-mask' />
    ) : (
      <Icon icon='gallery' size={20} color='darkGrey' />
    )}
  </ConversationOrderSummaryThumbnailStyled>
)
